import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getColleges(
      { rootGetters },
      { offset = 0, size = 25, search = '', isSearch = false } = {}
    ) {
      const searchController = !isSearch ? '' : `search=${search}`
      return new Promise((resolve, reject) => {
        axios({
          url: `${process.env.VUE_APP_URL}/branch/getAllBranches?offset=${offset}&page=${size}&${searchController}`,
          method: 'GET',
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    createCollege(context, data) {
      return axios({
        url: process.env.VUE_APP_URL + '/branch/sa',
        method: 'POST',
        data,
      })
    },
    deleteCollege(context, { id_branch, data }) {
      return axios({
        url: process.env.VUE_APP_URL + '/branch/sa/' + id_branch,
        method: 'DELETE',
        data,
      })
    },
    disableCollege(context, { id_branch, data }) {
      return axios({
        url: process.env.VUE_APP_URL + '/branch/sa/' + id_branch + '/disable',
        method: 'PUT',
        data,
      })
    },
    enableCollege(context, id_branch) {
      return axios({
        url: process.env.VUE_APP_URL + '/branch/sa/' + id_branch + '/enable',
        method: 'PUT',
      })
    },
    /**
     *
     * @param {*} context
     * @param {{id_branch: string, data: { status: "DROPPED"|"TEMPORAL_DROP" }}} data
     */
    dropCollege(context, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/branch/sa/${data.id_branch}/drop`,
        method: 'PUT',
        data: data.data,
      })
    },
    listCollege(context, params) {
      return axios({
        url: process.env.VUE_APP_URL + '/branch/getAllBranches',
        method: 'GET',
        params,
      })
    },
    filterCollege(context, params) {
      return axios({
        url: process.env.VUE_APP_URL + '/branch/getAllBranches',
        method: 'GET',
        params,
      })
    },
    updateProfileSA({ commit }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/sa/web/profile',
          data: obj,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              commit(
                'updateUser',
                {
                  user: response.data,
                },
                {
                  root: true,
                }
              )
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    retrieveCollege(context, id_branch) {
      return axios({
        url: process.env.VUE_APP_URL + '/branch/sa/' + id_branch,
        method: 'GET',
      })
    },
    editCollege(_, { id_branch, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/branch/sa/${id_branch}`,
        method: 'PUT',
        data,
      })
    },
  },
}
